(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["magsnap-bundle-builder"] && !Shopify.designMode) return;
  try {
    
(() => {
  const normal = value => String(value || '').trim().toLowerCase();
  const escapeHTML = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const optionsOf = variant => (variant.options || [variant.option1, variant.option2, variant.option3]).filter(Boolean);
  function resolveVariant(product, device, isBackplate) {
    const matches = (product?.variants || []).filter(v => {
      const options = optionsOf(v).map(normal);
      return options.includes(normal(device)) && (!isBackplate || options.includes('magnetic back cover only'));
    });
    return matches.find(v => v.available) || null;
  }
  function getModels(base) {
    const models = new Set();
    base.forEach(item => (item.variants || []).forEach(v => optionsOf(v).filter(o => /^iPhone\s/i.test(o)).forEach(o => models.add(o))));
    return [...models].sort((a,b) => {
      const n = Number(b.match(/\d+/)?.[0] || 0) - Number(a.match(/\d+/)?.[0] || 0);
      const rank = x => /Pro Max/i.test(x) ? 0 : /Pro/i.test(x) ? 1 : /Plus/i.test(x) ? 2 : /Air/i.test(x) ? 3 : 4;
      return n || rank(a) - rank(b) || a.localeCompare(b);
    });
  }
  function cartItems(base, backs, device, bundleId, editURL) {
    if(!device || !base?.variant || backs.length!==3 || new Set(backs.map(x=>x.item.h)).size!==3 || backs.some(x=>!x.variant))throw new Error('Incomplete set');
    const common = {_magsnap_bundle_id:bundleId,_magsnap_device:device,_magsnap_case_color:base.item.n,_magsnap_case_handle:base.item.h,_magsnap_edit_url:editURL,_magsnap_bundle_label:'MagSnap Set',_magsnap_bundle_version:'2'};
    return [{id:Number(base.variant.id),quantity:1,properties:{...common,_magsnap_bundle_role:'base',_magsnap_design:'Base Case',_magsnap_sort:'0'}},...backs.map((entry,i)=>({id:Number(entry.variant.id),quantity:1,properties:{...common,_magsnap_bundle_role:'backplate',_magsnap_design:entry.item.n,_magsnap_design_handle:entry.item.h,_magsnap_sort:String(i+1)}}))];
  }
  function init(R) {
    if (R.dataset.ready) return;
    R.dataset.ready = '1';
    const config = JSON.parse(R.querySelector('[data-mset-config]').textContent);
    const $ = selector => R.querySelector(selector);
    const $$ = selector => [...R.querySelectorAll(selector)];
    const t = (key, vars={}) => Object.entries(vars).reduce((text,[k,v]) => text.replaceAll(`{${k}}`, String(v)), config.text[key] || key);
    const base = config.base.map(x => ({...x,n:t(x.colour),variants:x.variants || []}));
    const back = [...new Map(config.back.map(x => [x.h,x])).values()];
    const items = new Map([...base,...back].map(x => [x.h,x]));
    const models = getModels(base);
    const query = new URLSearchParams(location.search);
    const previewTheme = query.get('preview_theme_id');
    const editingBundle = '';
    const root = config.root.endsWith('/') ? config.root : config.root + '/';
    const state = {device:'',base:null,backs:new Map(),busy:false,filter:'all',search:'',replace:null,detail:null,cartUncertain:false};
    const cache = new Map();
    const products = new Map();
    const failed = new Set();
    const pending = new Set();
    const cardNodes = new Map();
    const caseNodes = new Map();
    const device = $('[data-device]');
    const review = $('[data-review-dialog]');
    const detail = $('[data-detail-dialog]');
    const replacement = $('[data-replace-dialog]');
    const summary = $('[data-summary]');
    const wide = matchMedia('(min-width:1100px)');
    const reduced = matchMedia('(prefers-reduced-motion:reduce)');
    const storageKey = `magsnap-builder-v2:${previewTheme || 'store'}:${config.currency}`;
    let generation = 0;
    let messageTimer;
    let resultsTimer;
    let keyboardInteraction = true;
    const onPointerInput = () => { keyboardInteraction = false; };
    const onKeyboardInput = event => {
      if (['Tab','Enter',' ','ArrowUp','ArrowDown','ArrowLeft','ArrowRight','Home','End'].includes(event.key)) keyboardInteraction = true;
    };
    document.addEventListener('pointerdown',onPointerInput,true);
    document.addEventListener('keydown',onKeyboardInput,true);
    let previousOverflow = '';
    let scrollLocked = false;
    let availabilityObserver;
    const queue = [];
    const queued = new Set();
    let workers = 0;
    const check = '<span class="mset-check" aria-hidden="true"><svg viewBox="0 0 20 20"><path d="m4 10 4 4 8-9"/></svg></span>';
    const zoom = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10" cy="10" r="6.5"/><path d="m15 15 6 6M7 10h6M10 7v6"/></svg>';
    const image = (item, size=500) => {
      if (!item.i) return '';
      try { const url = new URL(item.i,location.origin); if (url.hostname === 'cdn.shopify.com') url.searchParams.set('width',size); return url.href; } catch (_) { return ''; }
    };
    const img = (item,size=500,alt='') => `<img src="${escapeHTML(image(item,size))}" alt="${escapeHTML(alt)}" width="${size}" height="${size}" loading="lazy" decoding="async">`;
    const currency = config.currency || 'USD';
    const previewAmount = currency === 'USD' ? config.previewUSD : currency === 'HKD' ? config.previewHKD : null;
    const price = previewAmount === null ? '—' : new Intl.NumberFormat(config.locale || 'en',{style:'currency',currency,currencyDisplay:'narrowSymbol',maximumFractionDigits:2}).format(previewAmount);
    const priceLabel = previewAmount === null ? t('currency_notice') : t('preview_price');
    $('[data-price]').textContent = previewAmount === null ? '—' : `${currency} ${price}`;
    $('[data-mobile-price]').textContent = previewAmount === null ? t('your_set') : `${currency} ${price}`;
    $('[data-price-label]').textContent = priceLabel;
    $('[data-price-note]').textContent = previewAmount === null ? t('currency_notice') : t('preview_notice');

    function save() {
      try { sessionStorage.setItem(storageKey,JSON.stringify({at:Date.now(),device:state.device,base:state.base?.item.h || '',backs:[...state.backs.keys()]})); } catch (_) {}
    }
    function say(text, persistent=false, bag=false) {
      clearTimeout(messageTimer);
      $('[data-message-copy]').textContent = text;
      $('[data-message]').hidden = !text || review.open || detail.open;
      $$('[data-dialog-message]').forEach(node=>{node.textContent=text;node.hidden=!text;});
      $('[data-message-link]').hidden = !bag;
      $('[data-message-link]').href = cartURL();
      if (text && !persistent) messageTimer = setTimeout(()=>{$('[data-message]').hidden=true;},6500);
    }
    async function request(url, options={}) {
      const response = await fetch(url,{...options,headers:{Accept:'application/json',...options.headers}});
      const data = await response.json().catch(()=>null);
      if (!response.ok || data === null) throw new Error(data?.description || data?.message || t('network_error'));
      return data;
    }
    function product(handle, fresh=false) {
      if (fresh) cache.delete(handle);
      if (!cache.has(handle)) {
        const promise = request(root+'products/'+encodeURIComponent(handle)+'.js',{cache:fresh?'no-store':'default'}).then(p=>{products.set(handle,p);failed.delete(handle);return p;}).catch(error=>{cache.delete(handle);failed.add(handle);throw error;});
        cache.set(handle,promise);
      }
      return cache.get(handle);
    }
    function available(item,isBack) {
      const p = products.get(item.h) || (!isBack ? item : null);
      return p && state.device ? Boolean(resolveVariant(p,state.device,isBack)) : null;
    }
    const cardRenderKeys=new WeakMap();
    function syncCard(item,isBack) {
      const el = isBack ? cardNodes.get(item.h) : caseNodes.get(item.h);
      const selected = isBack ? state.backs.has(item.h) : state.base?.item.h === item.h;
      const availability = available(item,isBack);
      const loading = pending.has(item.h);
      const key=[selected,availability,loading,state.busy,failed.has(item.h)].join('|');
      if(cardRenderKeys.get(el)===key)return;
      cardRenderKeys.set(el,key);
      const label = selected ? t('selected') : loading ? t('checking') : availability === false ? t('unavailable') : failed.has(item.h) ? t('check_retry') : t('select');
      if (isBack) {
        el.dataset.selected=String(selected);el.dataset.unavailable=String(availability===false);el.dataset.pending=String(loading);
        el.querySelectorAll('[data-pick]').forEach(b=>{b.setAttribute('aria-pressed',String(selected));b.setAttribute('aria-label',t(selected?'remove_named':'add_named',{name:item.n}));b.disabled=state.busy || (!selected && availability===false);});
        const status=el.querySelector('[data-card-state]');
        status.textContent=label;
        status.hidden=!(loading || availability===false || failed.has(item.h));
      } else {
        el.setAttribute('aria-pressed',String(selected));el.disabled=state.busy || availability===false;
        el.querySelector('[data-case-state]').textContent=availability===false?t('unavailable'):selected?t('selected'):'';
      }
    }
    function nextLabel() {
      if(state.busy)return t('checking');
      if(!state.device)return t('choose_device');
      if(!state.base)return t('choose_case');
      if(state.backs.size<3){const count=3-state.backs.size;return t('choose_more',{count,piece:t(count===1?'backplate':'backplates')});}
      return t(editingBundle?'update':'add');
    }
    let slotsKey=null;
    function renderSlots() {
      const chosen=[...state.backs.values()];
      const key=chosen.map(entry=>entry.item.h).join('|');
      if(key===slotsKey)return;
      slotsKey=key;
      $('[data-slots]').innerHTML=[0,1,2].map(i=>{
        const entry=chosen[i];
        if(!entry)return `<div class="mset-slot"><div class="mset-slot-image"><button type="button" class="mset-slot-empty" data-edit="back" aria-label="${escapeHTML(t('empty_slot',{count:i+1}))}"><span aria-hidden="true">+</span><span>${escapeHTML(t('slot',{count:i+1}))}</span></button></div></div>`;
        return `<div class="mset-slot"><div class="mset-slot-image">${img(entry.item,220)}<button type="button" class="mset-slot-remove" data-remove="${escapeHTML(entry.item.h)}" aria-label="${escapeHTML(t('remove_named',{name:entry.item.n}))}"><span aria-hidden="true">×</span></button></div><p>${escapeHTML(entry.item.n)}</p></div>`;
      }).join('');
    }
    function render() {
      device.disabled=state.busy || !models.length;
      $('[data-device-caption]').textContent=state.device;
      $('[data-case-caption]').textContent=state.base?.item.n || '';
      $('[data-summary-device]').textContent=state.device || t('not_selected');
      $('[data-summary-case]').textContent=state.base?.item.n || t('not_selected');
      $('[data-count]').textContent=`${state.backs.size} / 3`;
      $('[data-mobile-count]').textContent=`${state.backs.size} / 3`;
      $('[data-selected-count]').textContent=t('selected_count',{count:state.backs.size});
      const progress=Number(Boolean(state.device))+Number(Boolean(state.base))+state.backs.size;
      $('[data-progress]').setAttribute('aria-valuenow',String(progress));
      $('[data-progress] span').style.width=`${progress*20}%`;
      $('[data-next-hint]').textContent=progress===5?t('all_ready'):t('selected_count',{count:state.backs.size});
      $$('[data-next]').forEach(b=>{b.textContent=nextLabel();b.disabled=state.busy || state.cartUncertain;});
      base.forEach(item=>syncCard(item,false));back.forEach(item=>syncCard(item,true));
      renderSlots();filterCards();save();
      if(state.detail)syncDetail();
    }
    let filterKey=null;
    function filterCards() {
      const key=[state.filter,normal(state.search),...[...state.backs.keys()]].join("|");
      if(key===filterKey){observeVisible();return;}
      filterKey=key;
      let visible=0;
      const search=normal(state.search);
      back.forEach(item=>{
        const matches=(state.filter==='all' || (state.filter==='selected'?state.backs.has(item.h):item.c.includes(state.filter))) && (!search || normal(item.n).includes(search));
        const node=cardNodes.get(item.h);if(node.hidden===matches)node.hidden=!matches;if(matches)visible++;
      });
      $$('[data-filter]').forEach(b=>{b.setAttribute('aria-pressed',String(b.dataset.filter===state.filter));if(b.dataset.filter==='selected')b.textContent=t('selected_filter',{count:state.backs.size});});
      clearTimeout(resultsTimer);
      resultsTimer=setTimeout(()=>{if(R.isConnected)$('[data-results]').textContent=t('results',{count:visible});},250);
      $('[data-empty]').hidden=visible>0;
      $('[data-empty-copy]').textContent=state.filter==='selected' && !state.backs.size?t('no_selected'):t('no_results');
      observeVisible();
    }
    function observeVisible() {
      if(!availabilityObserver || !state.device)return;
      back.forEach(item=>{const node=cardNodes.get(item.h);if(!node.hidden && !products.has(item.h) && !failed.has(item.h))availabilityObserver.observe(node);});
    }
    function pumpQueue() {
      if(!R.isConnected || !state.device)return;
      while(workers<3 && queue.length){
        const handle=queue.shift();queued.delete(handle);
        if(products.has(handle) || cardNodes.get(handle)?.hidden)continue;
        workers++;product(handle).catch(()=>{}).finally(()=>{workers--;if(R.isConnected){syncCard(items.get(handle),true);pumpQueue();}});
      }
    }
    function scrollToStep(step) {
      closeDialog(review);
      const target=step==='back'?$('#mset-back-'+R.id.slice(5)):$(`[data-step="${step}"]`);
      if(!target)return;
      if(target.tagName==='DETAILS')target.open=true;
      target.scrollIntoView({behavior:reduced.matches?'auto':'smooth',block:'start'});
      const focus=step==='device'?device:step==='case'?target.querySelector('summary'):target.querySelector('h2');
      focus?.focus({preventScroll:true});
    }
    function openDialog(dialog) {
      if(dialog.open)return;
      $$('[data-dialog-message]').forEach(node=>{node.hidden=true;});
      if(!scrollLocked){previousOverflow=document.documentElement.style.overflow;scrollLocked=true;document.documentElement.style.overflow='hidden';}
      dialog.showModal();
    }
    function closeDialog(dialog) {if(dialog.open)dialog.close();}
    function restoreScroll() {
      if(![review,detail,replacement].some(d=>d.open) && scrollLocked){document.documentElement.style.overflow=previousOverflow;scrollLocked=false;}
    }
    [review,detail,replacement].forEach(dialog=>{
      dialog.addEventListener('close',restoreScroll);
      dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)closeDialog(dialog);});
    });
    function positionSummary() {
      if(wide.matches){closeDialog(review);$('[data-summary-mount]').append(summary);}
      else review.append(summary);
    }
    wide.addEventListener('change',positionSummary);positionSummary();

    async function changeDevice(value,{quiet=false}={}) {
      if(state.busy)return false;
      if(value && !models.includes(value))return false;
      if(value)prepareBundleSdk().catch(()=>{});
      const oldDevice=state.device;
      const moveFocus=keyboardInteraction;
      const version=++generation;
      state.busy=true;render();
      try{
        const chosen=[...(state.base?[{...state.base,kind:'base'}]:[]),...[...state.backs.values()].map(x=>({...x,kind:'back'}))];
        const resolved=value?await Promise.all(chosen.map(async x=>({...x,variant:resolveVariant(await product(x.item.h),value,x.kind==='back')}))):chosen.map(x=>({...x,variant:null}));
        if(version!==generation)return false;
        state.device=value;device.value=value;
        const removed=[];
        resolved.forEach(entry=>{if(!entry.variant){removed.push(entry.item.n);if(entry.kind==='base')state.base=null;else state.backs.delete(entry.item.h);}else if(entry.kind==='base')state.base={item:entry.item,variant:entry.variant};else state.backs.set(entry.item.h,{item:entry.item,variant:entry.variant});});
        if(!quiet && oldDevice!==value && removed.length)say(t('removed_unavailable',{names:removed.join(', ')}),true);
        if(value && !quiet){$('[data-step="device"]').open=false;$('[data-step="case"]').open=true;if(moveFocus)$('[data-step="case"] summary').focus({preventScroll:true});}
        return true;
      }catch(_){device.value=oldDevice;say(t('load_error'),true);return false;}
      finally{state.busy=false;render();}
    }
    async function chooseCase(handle,{quiet=false}={}) {
      if(state.busy)return false;
      if(!state.device){say(t('choose_device'));scrollToStep('device');return false;}
      const item=base.find(x=>x.h===handle);if(!item)return false;
      const moveFocus=keyboardInteraction;
      state.busy=true;render();
      try{
        const variant=resolveVariant(await product(handle),state.device,false);
        if(!variant){say(`${item.n}: ${t('unavailable')}`,true);return false;}
        state.base={item,variant};
        if(!quiet){$('[data-step="case"]').open=false;if(moveFocus)$('[id^="mset-back-title-"]').focus({preventScroll:true});}
        return true;
      }catch(_){say(t('load_error'),true);return false;}
      finally{state.busy=false;render();}
    }
    function removeBack(handle) {
      if(state.busy)return;
      const entry=state.backs.get(handle);if(!entry)return;
      const refocus=state.filter==='selected' && cardNodes.get(handle)?.contains(document.activeElement);
      state.backs.delete(handle);render();if(refocus)$('[data-filter="selected"]').focus({preventScroll:true});
    }
    function askReplacement(entry) {
      state.replace=entry;
      $('[data-replace-copy]').textContent=t('replace_help',{name:entry.item.n});
      $('[data-replace-list]').innerHTML=[...state.backs.values()].map(x=>`<button type="button" class="mset-replace-choice" data-replace="${escapeHTML(x.item.h)}" aria-label="${escapeHTML(t('replace_named',{name:x.item.n}))}">${img(x.item,160)}<span>${escapeHTML(x.item.n)}</span></button>`).join('');
      closeDialog(detail);openDialog(replacement);
    }
    async function chooseBack(handle,{quiet=false,allowReplace=true}={}) {
      if(state.busy)return false;
      if(!state.device){closeDialog(detail);say(t('choose_device'));scrollToStep('device');return false;}
      const item=back.find(x=>x.h===handle);if(!item)return false;
      if(state.backs.has(handle)){removeBack(handle);return true;}
      pending.add(handle);state.busy=true;render();
      try{
        const variant=resolveVariant(await product(handle),state.device,true);
        if(!variant){say(`${item.n}: ${t('unavailable')}`,true);return false;}
        const entry={item,variant};
        if(state.backs.size===3){if(allowReplace)askReplacement(entry);return false;}
        state.backs.set(handle,entry);
        return true;
      }catch(_){say(t('load_error'),true);return false;}
      finally{state.busy=false;pending.delete(handle);render();}
    }
    function replaceBack(handle) {
      if(state.busy || !state.replace || !state.backs.has(handle))return;
      const entries=[...state.backs.entries()].map(([h,v])=>h===handle?[state.replace.item.h,state.replace]:[h,v]);
      state.backs=new Map(entries);state.replace=null;closeDialog(replacement);render();
    }
    function syncDetail() {
      const selected=state.backs.has(state.detail.h);
      const unavailable=available(state.detail,true)===false;
      const button=$('[data-detail-select]');
      button.disabled=state.busy || (!selected && unavailable);
      button.textContent=selected?t('remove'):unavailable?t('unavailable'):state.backs.size===3?t('replace_button'):state.device?t('select'):t('choose_device');
    }
    function showDetail(handle) {
      const item=back.find(x=>x.h===handle);if(!item)return;
      state.detail=item;$('[data-detail-title]').textContent=item.n;$('[data-detail-image]').src=image(item,1200);$('[data-detail-image]').alt=item.n;syncDetail();openDialog(detail);
    }
    function cartURL() {
      const url=new URL(config.cart || root+'cart',location.origin);if(previewTheme)url.searchParams.set('preview_theme_id',previewTheme);return url.pathname+url.search;
    }
    function editURL(id) {
      const q=new URLSearchParams();q.set('device',state.device);q.set('case',state.base.item.h);q.set('backs',[...state.backs.keys()].join(','));q.set('edit_bundle',id);if(previewTheme)q.set('preview_theme_id',previewTheme);return location.pathname+'?'+q.toString();
    }
    let sdkPromise;
    let preparedSdkPromise;
    function prepareBundleSdk() {
      if (!preparedSdkPromise) preparedSdkPromise = (async () => {
        const sdk = await getBundleSdk();
        await sdk.f.resetBundle();
        await loadBundleProducts(sdk);
        return sdk;
      })().catch(error => { preparedSdkPromise = null; throw error; });
      return preparedSdkPromise;
    }
    function getBundleSdk() {
      if (!sdkPromise) sdkPromise = new Promise((resolve, reject) => {
        const deadline = Date.now() + 20000;
        function check() {
          const instance = window.gbbSdk?.['SDK-575188'];
          if (instance?.f) return resolve(instance);
          if (Date.now() >= deadline) return reject(new Error(t('load_error')));
          setTimeout(check, 100);
        }
        check();
      }).catch(error => { sdkPromise = null; throw error; });
      return sdkPromise;
    }
    function waitForCartResult(promise) {
      return new Promise((resolve, reject) => {
        const timeout = setTimeout(() => reject(new Error(t('add_error'))), 60000);
        Promise.resolve(promise).then(resolve, reject).finally(() => clearTimeout(timeout));
      });
    }
    async function loadBundleProducts(sdk) {
      let categories = ['category13190', 'category40916'];
      for (let page = 0; categories.length && page < 20; page++) {
        const result = await sdk.f.fetchProducts(categories);
        if (!result || categories.some(id => !result[id])) throw new Error(t('load_error'));
        categories = categories.filter(id => result[id].hasNextPage === true);
      }
      if (categories.length) throw new Error(t('load_error'));
    }
    function requireSdkResult(result) {
      if (!result?.ok) throw new Error(result?.data?.message || result?.data?.code || t('add_error'));
      return result.data;
    }
    async function addSet() {
      if(state.busy || state.cartUncertain || !state.device || !state.base || state.backs.size!==3)return;
      state.busy=true;render();$$('[data-next]').forEach(b=>b.textContent=t('adding'));
      let submitted=false;
      try{
        const all=[state.base,...state.backs.values()];
        const [sdk,verified]=await Promise.all([
          prepareBundleSdk(),
          Promise.all(all.map(async(entry,index)=>({item:entry.item,variant:resolveVariant(await product(entry.item.h,true),state.device,index>0)})))
        ]);
        const invalid=verified.filter(x=>!x.variant);
        if(invalid.length){invalid.forEach(x=>{if(state.base?.item.h===x.item.h)state.base=null;state.backs.delete(x.item.h);});throw new Error(invalid.map(x=>x.item.n).join(', ')+': '+t('unavailable'));}
        if(new Set(verified.slice(1).map(x=>x.item.h)).size!==3)throw new Error(t('choose_backs'));
        const missing = verified.filter(entry => !sdk.f.getVariantDataById(String(entry.variant.id)));
        if (missing.length) { preparedSdkPromise = null; throw new Error(missing.map(entry => entry.item.n).join(', ') + ': ' + t('load_error')); }
        preparedSdkPromise = null;
        for(let i=0;i<verified.length;i++) {
          requireSdkResult(await sdk.f.addProductToBundle({stepId:i===0?'productsData1':'productsData2',categoryId:i===0?'category13190':'category40916',variantId:String(verified[i].variant.id),quantity:1,showToast:false}));
        }
        requireSdkResult(await sdk.f.validateBeforeAddBundleToCart());
        submitted=true;
        requireSdkResult(await waitForCartResult(sdk.f.addBundleToCart({showToast:false})));
        try{sessionStorage.removeItem(storageKey);}catch(_){}
        state.cartUncertain=true;
        location.assign(cartURL());
      }catch(error){
        if(submitted){state.cartUncertain=true;closeDialog(review);say(t('add_error'),true,true);}
        else say(error.message || t('network_error'),true);
      }finally{state.busy=false;render();}
    }
    function next() {
      if(state.busy || state.cartUncertain)return;
      if(!state.device)return scrollToStep('device');
      if(!state.base)return scrollToStep('case');
      if(state.backs.size<3)return scrollToStep('back');
      addSet();
    }

    device.innerHTML=`<option value="">${escapeHTML(t('device_placeholder'))}</option>`+models.map(model=>`<option value="${escapeHTML(model)}">${escapeHTML(model)}</option>`).join('');
    $('[data-cases]').innerHTML=base.map(item=>`<button type="button" class="mset-case" data-case="${escapeHTML(item.h)}" aria-pressed="false" aria-label="${escapeHTML(t('add_named',{name:item.n+' '+t('base_case')}))}"><span class="mset-case-image">${img(item,400)}</span>${check}<span>${escapeHTML(item.n)}</span><span class="mset-case-state" data-case-state></span></button>`).join('');
    $$('[data-case]').forEach(el=>caseNodes.set(el.dataset.case,el));
    $('[data-backs]').innerHTML=back.map(item=>`<article class="mset-card" data-handle="${escapeHTML(item.h)}"><div class="mset-card-visual"><button type="button" class="mset-card-pick" data-pick="${escapeHTML(item.h)}" aria-pressed="false" aria-label="${escapeHTML(t('add_named',{name:item.n}))}">${img(item)}${check}</button><button type="button" class="mset-zoom" data-zoom="${escapeHTML(item.h)}" aria-label="${escapeHTML(t('zoom_named',{name:item.n}))}">${zoom}</button></div><h3 class="mset-card-name">${escapeHTML(item.n)}</h3><p class="mset-card-status" data-card-state hidden></p></article>`).join('');
    $$('[data-handle]').forEach(el=>cardNodes.set(el.dataset.handle,el));
    let revealObserver;
    if('IntersectionObserver' in window && !reduced.matches){
      revealObserver=new IntersectionObserver(entries=>{
        entries.forEach(entry=>{
          if(!entry.isIntersecting)return;
          revealObserver.unobserve(entry.target);
          if(reduced.matches)return;
          entry.target.classList.add('mset-enter');
          entry.target.addEventListener('animationend',()=>entry.target.classList.remove('mset-enter'),{once:true});
        });
      },{threshold:0.08});
      cardNodes.forEach(node=>revealObserver.observe(node));
    }
    const categories=['all',...['cat','floral','hearts_bows','food','nature','graphic','dots_stripes','retro'].filter(c=>back.some(x=>x.c.includes(c))),'selected'];
    $('[data-filters]').innerHTML=categories.map(c=>`<button type="button" class="mset-filter" data-filter="${c}" aria-pressed="${c==='all'}">${escapeHTML(c==='selected'?t('selected_filter',{count:0}):t(c))}</button>`).join('');
    if('IntersectionObserver' in window){availabilityObserver=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(!entry.isIntersecting)return;availabilityObserver.unobserve(entry.target);const h=entry.target.dataset.handle;if(!queued.has(h)&&!products.has(h)){queued.add(h);queue.push(h);}});pumpQueue();},{rootMargin:'240px'});}
    device.addEventListener('change',()=>changeDevice(device.value));
    $('[data-search]').addEventListener('input',event=>{state.search=event.target.value;filterCards();});
    function toggleSearch(open) {
      $('[data-search-panel]').hidden=!open;
      $('[data-filters]').hidden=open;
      R.querySelector('.mset-toolbar').classList.toggle('mset-search-open',open);
      $('[data-search-toggle]').setAttribute('aria-expanded',String(open));
      if(open)$('[data-search]').focus();
      else {state.search='';$('[data-search]').value='';filterCards();$('[data-search-toggle]').focus();}
    }
    $('[data-search-toggle]').addEventListener('click',()=>toggleSearch($('[data-search-panel]').hidden));
    $('[data-search]').addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();toggleSearch(false);}});

    const flights = new Set();
    const cancelFlights = () => { for(const stop of [...flights])stop(); };
    window.addEventListener('scroll',cancelFlights,{passive:true,capture:true});
    window.addEventListener('resize',cancelFlights,{passive:true});
    reduced.addEventListener('change',cancelFlights);
    function flightOrigin(node) {
      if(wide.matches || innerWidth>649 || reduced.matches || !node)return null;
      const rect=node.getBoundingClientRect();
      if(!rect.width || rect.bottom<=0 || rect.top>=innerHeight)return null;
      return rect;
    }
    function flySelection(origin,item) {
      if(!origin || reduced.matches || innerWidth>649 || !R.isConnected)return;
      const target=$('[data-review]');
      const end=target.getBoundingClientRect();
      if(!end.width || !end.height)return;
      cancelFlights();
      const ghost=document.createElement('img');
      ghost.className='mset-flying-item';ghost.alt='';ghost.setAttribute('aria-hidden','true');
      ghost.src=image(item,220);ghost.width=origin.width;ghost.height=origin.height;
      Object.assign(ghost.style,{left:origin.left+'px',top:origin.top+'px',width:origin.width+'px',height:origin.height+'px'});
      document.body.append(ghost);
      if(!ghost.animate){ghost.remove();return;}
      const dx=end.left+end.width/2-origin.left-origin.width/2;
      const dy=end.top+end.height/2-origin.top-origin.height/2;
      const scale=Math.min(32/origin.width,40/origin.height);
      let pulse;
      const lift=Math.min(100,Math.max(24,origin.top-12));
      const arc=Array.from({length:25},(_,i)=>{
        const t=i/24;
        const x=2*(1-t)*t*(dx*.25)+t*t*dx;
        const y=2*(1-t)*t*(-lift)+t*t*dy;
        const size=1-(1-scale)*t;
        return {offset:t,transform:`translate(${x}px,${y}px) scale(${size}) rotate(${-8*Math.sin(Math.PI*t)}deg)`,opacity:t<.8?.95:.95*(1-t)/.2};
      });
      const travel=ghost.animate(arc,{duration:400,easing:'cubic-bezier(.25,.1,.4,1)',fill:'forwards'});
      const stop=()=>{travel.cancel();pulse?.cancel();ghost.remove();flights.delete(stop);};
      flights.add(stop);
      travel.onfinish=()=>{
        ghost.remove();
        if(reduced.matches || !R.isConnected){stop();return;}
        pulse=target.animate([{transform:'scale(1)'},{transform:'scale(1.04)'},{transform:'scale(1)'}],{duration:180,easing:'ease-out'});
        pulse.onfinish=stop;
      };
    }
    async function selectWithFlight(handle,isBase,node) {
      const item=items.get(handle);
      const wasSelected=isBase?state.base?.item.h===handle:state.backs.has(handle);
      const origin=flightOrigin(node?.querySelector('img') || node);
      const ok=isBase?await chooseCase(handle):await chooseBack(handle);
      if(ok && !wasSelected && item)flySelection(origin,item);
      return ok;
    }

    R.addEventListener('click',event=>{
      const target=event.target.closest('button,a');if(!target || !R.contains(target))return;
      if(target.matches('[data-case]'))selectWithFlight(target.dataset.case,true,target);
      else if(target.matches('[data-pick]'))selectWithFlight(target.dataset.pick,false,target);
      else if(target.matches('[data-zoom]'))showDetail(target.dataset.zoom);
      else if(target.matches('[data-filter]')){state.filter=target.dataset.filter;filterCards();}
      else if(target.matches('[data-reset-filters]')){state.filter='all';state.search='';$('[data-search]').value='';filterCards();}
      else if(target.matches('[data-remove]')){removeBack(target.dataset.remove);summary.querySelector('[data-edit="back"]')?.focus({preventScroll:true});}
      else if(target.matches('[data-edit]'))scrollToStep(target.dataset.edit);
      else if(target.matches('[data-next]'))next();
      else if(target.matches('[data-review]')){if(wide.matches)summary.scrollIntoView({behavior:'smooth',block:'nearest'});else openDialog(review);}
      else if(target.matches('[data-close-review]'))closeDialog(review);
      else if(target.matches('[data-close-detail]'))closeDialog(detail);
      else if(target.matches('[data-close-replace]')){state.replace=null;closeDialog(replacement);}
      else if(target.matches('[data-detail-select]'))selectWithFlight(state.detail.h,false,$('[data-detail-image]')).then(ok=>{if(ok)closeDialog(detail);});
      else if(target.matches('[data-replace]')){const item=state.replace?.item;const origin=flightOrigin(target);replaceBack(target.dataset.replace);if(item && state.backs.has(item.h))flySelection(origin,item);}
      else if(target.matches('[data-start]')){event.preventDefault();scrollToStep('device');}
      else if(target.matches('[data-dismiss-message]'))$('[data-message]').hidden=true;
    });
    const loadSelections = async() => {
      let saved;
      try{const value=JSON.parse(sessionStorage.getItem(storageKey));if(value && Date.now()-value.at<86400000)saved=value;}catch(_){}
      const hasQuery=query.has('device') || query.has('case') || query.has('backs');
      const desired=hasQuery?{device:query.get('device'),base:query.get('case'),backs:(query.get('backs')||'').split(',')}:saved;
      if(desired?.device && models.includes(desired.device)){
        await changeDevice(desired.device,{quiet:true});
        if(desired.base)await chooseCase(desired.base,{quiet:true});
        for(const handle of [...new Set(desired.backs || [])].slice(0,3)){if(handle)await chooseBack(handle,{quiet:true,allowReplace:false});}
        if(state.device)$('[data-step="device"]').open=false;if(state.base)$('[data-step="case"]').open=false;
      }
      if(editingBundle)say(t('edit_notice'),true);
      render();
    };
    prepareBundleSdk().catch(()=>{});
    loadSelections();
    if(!models.length)say(t('device_error'),true);
    const unload = event => {if(!event.target.contains(R))return;availabilityObserver?.disconnect();revealObserver?.disconnect();wide.removeEventListener('change',positionSummary);[review,detail,replacement].forEach(closeDialog);cancelFlights();window.removeEventListener('scroll',cancelFlights,true);window.removeEventListener('resize',cancelFlights);reduced.removeEventListener('change',cancelFlights);clearTimeout(messageTimer);clearTimeout(resultsTimer);document.removeEventListener('pointerdown',onPointerInput,true);document.removeEventListener('keydown',onKeyboardInput,true);document.removeEventListener('shopify:section:unload',unload);};
    document.addEventListener('shopify:section:unload',unload);
  }
  const boot = scope => scope.querySelectorAll('[data-mset]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(document),{once:true});else boot(document);
  document.addEventListener('shopify:section:load',event=>boot(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
